var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404IllustrationSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 328.002,
    height: 245,
    viewBox: "0 0 328.002 245",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_404_illustration",
    "data-name": "404_illustration",
    transform: "translate(-219.999 -201.077)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_blob_2",
    d: "M24.522.59C34.6-4.165,23.873,20.695,27.05,44.211S58.891,86.859,79.574,84.574,113.067,54.366,97.124,43.7c0,0,16.219.807,19.782,17.562s-4.835,31.814-17.148,32.683-18.715,8.792-23.344,8.674,1.681-2.552-.9-5.89-21-.338-43.251-10.806S5.233,64.748,1.072,49.746s4.817,2.359,9.438-.485.361-10.328.913-17.651,3.767-14.325,8.15-9.439S19.678,2.875,24.522.59Z",
    transform: "translate(314.708 285.164) rotate(45)",
    fill: "#fff",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "ic_blob_1",
    d: "M47.329,7.415c1.85-9.273,25.506-10.9,43.147,1.213s20.3,25.275,16.39,24.853,16.179,10.463,23.318,36.642-.4,56.556-23.318,73.537c0,0,15.062-15.519,12.34-43.867S84.254,65.762,77.7,58,76.26,38.559,88.147,36.722s1.8-16.42-11.07-16.805-22.886,2.7-24.64.243S18.247,23.3,11.8,48.1s-15.748,17.606-10,0,43.258-35.086,50.275-36.4S46.9,9.566,47.329,7.415Z",
    transform: "matrix(1, 0.017, -0.017, 1, 376.581, 212.39)",
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_404",
    transform: "translate(281 296.078)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2941",
    "data-name": "Path 2941",
    d: "M43.013,0C66.768,0,86.025,19.506,86.025,43.568S66.768,87.136,43.013,87.136,0,67.63,0,43.568,19.257,0,43.013,0Z",
    transform: "translate(61.937 2.863)",
    fill: "#003fb9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2940",
    "data-name": "Path 2940",
    d: "M43.013,0C66.768,0,86.025,19.506,86.025,43.568S66.768,87.136,43.013,87.136,0,67.63,0,43.568,19.257,0,43.013,0Z",
    transform: "translate(61.937 2.863)",
    fill: "#fff",
    opacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M140.269,145.948c5.343-2.614,7.937-4.741,7.443-1.8a32.068,32.068,0,0,0,.054,7.707s.889,1.7,3.5.942,2.411-1.127,3.524-1.127,8.37.185,6.131,3.011-1.3,4.141-3.341,4.713c-2.043.555-2.79,3.381-2.973,3.953a15.086,15.086,0,0,1-2.215,2.442l-4.65,1.826a42.086,42.086,0,0,0,5.018,6.111,40.915,40.915,0,0,0,3.324,3.042,9.081,9.081,0,0,1,4.1-1.37c2.411,0,2.776,1.312,3.96,1.812s1.058,0,1.058,0,1.113,1.384,2.323.757,5.472.055,6.216.055,4.089-1.5,5.6-.411,1.846.8,2.029,2.11c.142,1.014.071,3.073-1.9,6.6a41.908,41.908,0,0,0,13.459-.969c-1.806-1.086-.96-8.081-2.425-11.095-1.451-3-1.508-3.754-.96-5.083.565-1.312,1.677,0,2.607,0a3.41,3.41,0,0,0,2.793-3.2,23.07,23.07,0,0,1,.913-4.326s1.681-3.2,2.425-3.2,2.976.188,3.723-.185c.73-.384.73-.942,1.113-1.925.365-.987.551-5.426-.382-5.227a6.255,6.255,0,0,1-2.776-.771,23.143,23.143,0,0,0-3.355-.685c-.548.058-.747-1.754-.747-1.754s3.541-2.072,3.541-2.829c0-.74-1.3-.925-1.481-3.2s1.664-2.257,3.706-1.857,0,.915,0,2.7.183,1.613,2.425,0,1.664.1,2.229,0a19.888,19.888,0,0,1,3.338.569s-.183,4.614,0,9.324,7.061.185,9.107-1.5c.984-.812,3.845-.414,6.5.959a43.883,43.883,0,0,0-6.736-34.021.428.428,0,0,1-.494.086c-.818-.356-3.355.4-3.906-.158s-2.973.558-4.17,0a4.538,4.538,0,0,1-2.242-4.039c-.085-1.973-1.028-4.443-1.958-6.94-.3-.8-.352-1.172-.156-1.285a42.623,42.623,0,0,0-34.7-4.556c1.593,2.727,2.8,5.854,1.126,7.21-3.253,2.641-1.451,4.9.8,6.967s.72,3.953,0,4.71c-.7.743-2,2.627-.8,3.569,1.214.942,3.892,2.072,1.988,3.2-1.887,1.141-.774,3.953-3.947,1.514-3.155-2.456-2.043-4.713-4.454-4.713s-2.79,2.826-5.948,3.771-3.338.754-4.268.37-.933-2.812-2.976-4.9a2.844,2.844,0,0,0-4.663.572c-.355.942-.947,5.326,0,5.868s-.169,3.542-2.032,4.11c-1.745.531-3.689-2.411-4.369-.469a3.312,3.312,0,0,0-.112.469,1.258,1.258,0,0,1-.054.216A43.642,43.642,0,0,0,140.269,145.948Zm44.257,21.162c-2.973.754,0,0-3.115-3.576s1.759-1.13,1.759-1.13a45.208,45.208,0,0,0,1.366-5.272c.382-2.261,3.148,0,4.684,0s3.111,2.261,1.285,5.272c0,0,.156,1.881-1.285,1.507S187.5,166.356,184.525,167.11Zm-1.356,5.083c.876-.565,3.03.754,2.678,3.2l-2.79.754a14.612,14.612,0,0,1-2.685-2.418C179.564,172.628,182.3,172.758,183.169,172.193Zm-22.806-33.511c0-1.884.555-3.275,2.046-3.624,2.4-.565,2.983,1.74,5.117,1.928s1.2,5.929,1.2,5.929.761,2.918-3.057,1.98-5.864-.209-6.233-1.613S160.363,140.567,160.363,138.683Z",
    transform: "translate(-78.221 -96.487)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(147.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M182.374,111.345a6.545,6.545,0,1,1-6.544-6.547A6.542,6.542,0,0,1,182.374,111.345Z",
    transform: "translate(-169.283 -104.798)",
    fill: "#407bff",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M182.374,111.345a6.545,6.545,0,1,1-6.544-6.547A6.542,6.542,0,0,1,182.374,111.345Z",
    transform: "translate(-169.283 -104.798)",
    fill: "#fff",
    opacity: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 1.329,
    cy: 1.329,
    r: 1.329,
    transform: "translate(2.001 7.456)",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M172.481,106.792a.243.243,0,1,1-.243-.243A.242.242,0,0,1,172.481,106.792Z",
    transform: "translate(-162.826 -100.628)",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M171.41,108.351a.243.243,0,1,1-.243-.243A.242.242,0,0,1,171.41,108.351Z",
    transform: "translate(-165.377 -96.914)",
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M172.1,105.3a.243.243,0,1,1-.243-.244A.245.245,0,0,1,172.1,105.3Z",
    transform: "translate(-163.734 -104.193)",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M173.339,106.977a.243.243,0,1,1-.244-.243A.242.242,0,0,1,173.339,106.977Z",
    transform: "translate(-160.783 -100.187)",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M170.362,106.37a.243.243,0,1,1-.243-.244A.242.242,0,0,1,170.362,106.37Z",
    transform: "translate(-167.873 -101.633)",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M172.179,106.252a.84.84,0,1,1-.842-.842A.839.839,0,0,1,172.179,106.252Z",
    transform: "translate(-166.389 -103.34)",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M173.573,108.522a.842.842,0,1,1-.842-.839A.842.842,0,0,1,173.573,108.522Z",
    transform: "translate(-163.076 -97.927)",
    opacity: 0.1
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2818",
    "data-name": "Path 2818",
    d: "M-64.12-36.885V-48.466l25.9-37.934h15.654v37.094h6.72v12.421h-6.72v10.91H-36.583v-10.91ZM-35.6-70.622-49.368-49.306H-35.6ZM92.608-36.885V-48.466l25.9-37.934H134.16v37.094h6.72v12.421h-6.72v10.91H120.145v-10.91Zm28.521-33.737L107.36-49.306h13.769Z",
    transform: "translate(64.12 101.666)",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_Character",
    transform: "translate(470.342 368.395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M342.243,193.3,353.2,192.5l.094-.428c.36-1.69,1.642-8.032,1.441-12.067a8.574,8.574,0,0,0-.327-2.121c-1.34-4.16-14.478-12.546-14.478-12.546l-.64,5.047,7.726,9.673C344.642,185.393,342.243,193.3,342.243,193.3Z",
    transform: "translate(-310.448 -150.219)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M342.243,193.3,353.2,192.5l.094-.428c.36-1.69,1.642-8.032,1.441-12.067a8.574,8.574,0,0,0-.327-2.121c-1.34-4.16-14.478-12.546-14.478-12.546l-.64,5.047,7.726,9.673C344.642,185.393,342.243,193.3,342.243,193.3Z",
    transform: "translate(-310.448 -150.219)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(0 56.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M287.275,286.037c-1.366.939-2.749,1.945-4.111,2.9-.677.491-1.36.961-2.031,1.425s-1.347.906-1.944,1.262c-.145.087-.291.171-.4.231s-.2.1-.175.112a.552.552,0,0,1,.124-.015h.032l-.034.007-.07.014-.28.054-.579.105c-.788.144-1.613.26-2.444.4-1.663.266-3.373.522-5.066.9l-.029.007a1.57,1.57,0,0,0-.042,3.053,35.1,35.1,0,0,0,5.269.875c.891.089,1.787.133,2.718.149.235,0,.463.006.707,0l.362-.012.091,0,.046,0,.111-.014c.147-.021.3-.046.441-.076a8.025,8.025,0,0,0,1.041-.322c.286-.107.528-.211.768-.317.94-.423,1.732-.869,2.532-1.316s1.547-.924,2.3-1.4c1.494-.968,2.926-1.949,4.338-3.048a3.09,3.09,0,0,0-3.639-4.992Z",
    transform: "translate(-264.313 -285.476)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M287.275,286.037c-1.366.939-2.749,1.945-4.111,2.9-.677.491-1.36.961-2.031,1.425s-1.347.906-1.944,1.262c-.145.087-.291.171-.4.231s-.2.1-.175.112a.552.552,0,0,1,.124-.015h.032l-.034.007-.07.014-.28.054-.579.105c-.788.144-1.613.26-2.444.4-1.663.266-3.373.522-5.066.9l-.029.007a1.57,1.57,0,0,0-.042,3.053,35.1,35.1,0,0,0,5.269.875c.891.089,1.787.133,2.718.149.235,0,.463.006.707,0l.362-.012.091,0,.046,0,.111-.014c.147-.021.3-.046.441-.076a8.025,8.025,0,0,0,1.041-.322c.286-.107.528-.211.768-.317.94-.423,1.732-.869,2.532-1.316s1.547-.924,2.3-1.4c1.494-.968,2.926-1.949,4.338-3.048a3.09,3.09,0,0,0-3.639-4.992Z",
    transform: "translate(-264.313 -285.476)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M296.929,304.178s2.221,3.339,1.718,5.34l.678-.226s-.186-3.681-2.221-5.226Z",
    transform: "translate(-282.629 -297.684)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(0 8.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M265.024,309.132l-2.976.371,1.795,2.8s2.635-.491,2.325-1.838Z",
    transform: "translate(-259.722 -309.132)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M255.273,312.059l2.36,1.884,1.76-.93-1.794-2.8Z",
    transform: "translate(-255.273 -309.841)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(0 8.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M265.024,309.132l-2.976.371,1.795,2.8s2.635-.491,2.325-1.838Z",
    transform: "translate(-259.722 -309.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M255.273,312.059l2.36,1.884,1.76-.93-1.794-2.8Z",
    transform: "translate(-255.273 -309.841)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M270.716,308.818s1.22,1.487.208,2.731l.4.164s1.617-1.025.071-3.06Z",
    transform: "translate(-265.415 -300.697)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M296.929,304.178s2.221,3.339,1.718,5.34l.678-.226s-.186-3.681-2.221-5.226Z",
    transform: "translate(-282.629 -297.684)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M270.716,308.818s1.22,1.487.208,2.731l.4.164s1.617-1.025.071-3.06Z",
    transform: "translate(-265.415 -300.697)",
    fill: "#003fb9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M333.139,156.227l-.5,2.919c-.011.145-.629.45-.774.44h0l-3.305-.187a.657.657,0,0,1-.576-.722c.195-1.443.36-2.122.59-3.944a34.515,34.515,0,0,1,.724-4.842c.426-1.5,1.9-1.039,1.849-.366a10.235,10.235,0,0,0,1.359,5.014A7.387,7.387,0,0,1,333.139,156.227Z",
    transform: "translate(-303.016 -139.419)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M333.425,156.41l-1.007,2.993c-.011.145-.411.193-.556.182h0l-3.305-.187a.657.657,0,0,1-.576-.722c.195-1.443.36-2.122.59-3.944a34.515,34.515,0,0,1,.724-4.842c.426-1.5,1.9-1.039,1.849-.366a10.235,10.235,0,0,0,1.359,5.014A10.064,10.064,0,0,1,333.425,156.41Z",
    transform: "translate(-303.016 -139.419)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M376.032,220.133c.36-1.69,1.642-8.032,1.441-12.067a25.825,25.825,0,0,0-3.539,10.089C373.755,220.284,374.722,220.722,376.032,220.133Z",
    transform: "translate(-333.186 -178.279)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M349.778,176.379a9.49,9.49,0,0,1,7.757-7.722s4.934-6.293,11.14-12.611l-3.317-17.29,3.587-1.811s7.622,12.966,6.495,21.436-13.665,20.484-13.665,20.484Z",
    transform: "translate(-317.336 -131.573)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M349.778,176.379a9.49,9.49,0,0,1,7.757-7.722s4.934-6.293,11.14-12.611l-3.317-17.29,3.587-1.811s7.622,12.966,6.495,21.436-13.665,20.484-13.665,20.484Z",
    transform: "translate(-317.336 -131.573)",
    fill: "#eef3ff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(30.987 35.701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M358.46,227.641a2.346,2.346,0,0,1-2.183,2.334l-8.232.573a2.344,2.344,0,0,1-2.4-1.637,2.3,2.3,0,0,1-.1-.539c0-.055-.007-.11-.007-.165a2.343,2.343,0,0,1,2.18-2.334l8.235-.573a2.347,2.347,0,0,1,2.5,2.176C358.457,227.531,358.46,227.586,358.46,227.641Z",
    transform: "translate(-345.539 -225.294)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M358.065,226.892a2.345,2.345,0,0,1-2.18,2.334l-8.235.573a2.337,2.337,0,0,1-2-.889,2.3,2.3,0,0,1-.1-.539c0-.055-.007-.11-.007-.165a2.343,2.343,0,0,1,2.18-2.334l8.235-.573a2.338,2.338,0,0,1,2,.889,2.306,2.306,0,0,1,.1.539C358.062,226.782,358.065,226.837,358.065,226.892Z",
    transform: "translate(-345.539 -225.294)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(22.237 42.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M371.746,249.877a5.892,5.892,0,0,0-4.174-5.53c-4.3-1.474-3.676,3.875-3.676,3.875l7.669,1.972Z",
    transform: "translate(-348.825 -244.09)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M371.746,249.877a5.892,5.892,0,0,0-4.174-5.53c-4.3-1.474-3.676,3.875-3.676,3.875l7.669,1.972Z",
    transform: "translate(-348.825 -244.09)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M337.5,245.837s4.338,1.038,5.211,4.581-5.2,11.327-7.732,12.708-12.646,2.7-13.847,1.256c-4.137-4.985,4.736-13.062,7.791-15.044S337.5,245.837,337.5,245.837Z",
    transform: "translate(-320.051 -245.237)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M321.132,264.383a.827.827,0,0,0,.2.168c.788.5,2.963.552,5.385.346a29.579,29.579,0,0,0,8.014-1.65c.091-.041.171-.082.248-.122,1.955-1.065,6.027-5.953,7.376-9.753a5.371,5.371,0,0,0,.358-2.953c-.875-3.543-5.211-4.582-5.211-4.582s-5.523,1.52-8.578,3.5S316.993,259.4,321.132,264.383Z",
    transform: "translate(-320.052 -245.237)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M323.775,282.787c.789.5,2.963.552,5.385.346,5-5.377,2.146-9.508,2.146-9.508C327.1,273.241,324.145,279.024,323.775,282.787Z",
    transform: "translate(-322.497 -263.474)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(22.064 37.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M340.328,234.916s-.732-3.747-1.573-4.205-10.03.369-11.206.809-7.517,5.993-7.942,7.558,1.5,5.623,1.5,5.623,6.564,1.311,9.24.2S339.64,236.971,340.328,234.916Z",
    transform: "translate(-319.545 -230.576)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M321.1,244.7s6.563,1.309,9.239.194,9.3-7.925,9.984-9.981c0,0-.731-3.747-1.573-4.205s-10.029.369-11.206.809-7.518,5.994-7.94,7.56a3.4,3.4,0,0,0,.036,1.438A21.338,21.338,0,0,0,321.1,244.7Z",
    transform: "translate(-319.546 -230.574)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M319.645,240.516c.887.167,6.659,1.2,9.125.174,2.675-1.118,9.3-7.925,9.985-9.981-.842-.458-10.029.369-11.206.809s-7.518,5.994-7.94,7.56A3.4,3.4,0,0,0,319.645,240.516Z",
    transform: "translate(-319.546 -230.574)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(10.36 42.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 8.554,
    cy: 8.554,
    r: 8.554,
    transform: "translate(0 11.258) rotate(-41.152)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 8.554,
    cy: 8.554,
    r: 8.554,
    transform: "translate(0 11.258) rotate(-41.152)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M307.782,271.223a8.211,8.211,0,1,0-10.568-4.813A8.22,8.22,0,0,0,307.782,271.223Z",
    transform: "translate(-292.835 -251.463)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 6.171,
    cy: 4.607,
    rx: 6.171,
    ry: 4.607,
    transform: "translate(10.039 18.161) rotate(-76.02)",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(7.963 6.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M324.029,284.159s1.6,1.576,2.078,1.18,1.4.82,2.172.13,2.286-2.7,1.523-4.6S324.186,281.321,324.029,284.159Z",
    transform: "translate(-318.75 -274.279)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M324.03,284.157s1.6,1.578,2.078,1.184a.485.485,0,0,1,.493-.034c.487.166,1.123.661,1.678.164.774-.693,2.286-2.706,1.522-4.6-.326-.813-1.4-.845-2.544-.393a5.8,5.8,0,0,0-.887.441,4.6,4.6,0,0,0-2.33,3.1C324.035,284.063,324.032,284.112,324.03,284.157Z",
    transform: "translate(-318.75 -274.279)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M324.03,284.714s1.6,1.578,2.078,1.184a.485.485,0,0,1,.493-.034c1.907-1.142,1.04-3.871.656-4.83a5.8,5.8,0,0,0-.887.441,17.491,17.491,0,0,0-2.33,3.1C324.035,284.62,324.032,284.669,324.03,284.714Z",
    transform: "translate(-318.75 -274.836)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M310.5,279.009a1.115,1.115,0,0,0,.174,0c1.642-.079,1.186-3.365.389-5.24-.355-.831-.835-1.212-1.271-1.232-.554-.031-1.041.51-1.132,1.431-.062.617.343,1.466.277,1.876S309.022,278.886,310.5,279.009Z",
    transform: "translate(-308.65 -269.258)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M310.5,279.009a1.115,1.115,0,0,0,.174,0c1.642-.079,1.186-3.365.389-5.24-.355-.831-.835-1.212-1.271-1.232-.554-.031-1.041.51-1.132,1.431-.062.617.343,1.466.277,1.876S309.022,278.886,310.5,279.009Z",
    transform: "translate(-308.65 -269.258)",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M311.539,279.011a1.118,1.118,0,0,0,.174,0c1.642-.079,1.186-3.365.389-5.24-.355-.831-.835-1.212-1.271-1.232a2.607,2.607,0,0,0-.352.293c-.545.541.006,2.633-.015,3.183A4.446,4.446,0,0,0,311.539,279.011Z",
    transform: "translate(-309.693 -269.26)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M317.852,270.042c.632,2.478,1.128,3.9.3,5.529a3.425,3.425,0,0,1-5.989.031c-1.227-2.022-2.054-5.735.026-7.445A3.528,3.528,0,0,1,317.852,270.042Z",
    transform: "translate(-310.136 -265.848)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(3.764 7.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M321,287.823c-.055.038-.117.074-.179.109l-1.2-.613s.043-.067.118-.167c.246-.345.841-1.077,1.38-1.014a.977.977,0,0,1,.179.045.943.943,0,0,1,.515.4C321.959,286.874,321.853,287.295,321,287.823Z",
    transform: "translate(-319.614 -286.135)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M321.518,286.183l-1.405,1.021-.154-.052c.246-.345.841-1.077,1.38-1.014A.977.977,0,0,1,321.518,286.183Z",
    transform: "translate(-319.84 -286.135)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M325.57,285.816a19.383,19.383,0,0,1-1.351,2.277,5.144,5.144,0,0,1-1.553.8",
    transform: "translate(-317.855 -277.977)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M322.241,294.278l.36-.135a.243.243,0,0,0,.142-.313h0a.243.243,0,0,0-.313-.143l-.36.135a.243.243,0,0,0-.142.313h0A.243.243,0,0,0,322.241,294.278Z",
    transform: "translate(-317.36 -283.136)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M331.4,277.973a2.4,2.4,0,0,1-.712,1.707c-.61.593-1.328.146-1.506-.642-.16-.709-.035-1.872.744-2.168A1.1,1.1,0,0,1,331.4,277.973Z",
    transform: "translate(-322.092 -272.054)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M310.783,266.153c.756-.242,2.73-.573,3.17-.172s1.355,5.207,2.338,5.491,2.712-1.329,2.566-2.784a3.247,3.247,0,0,0-1.05-2.161,3.78,3.78,0,0,0-4.245-3.53,4.929,4.929,0,0,0-4.9,4.7A4.182,4.182,0,0,1,310.783,266.153Z",
    transform: "translate(-308.656 -262.981)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M310.783,266.153c.756-.242,2.73-.573,3.17-.172s1.355,5.207,2.338,5.491,2.712-1.329,2.566-2.784a3.247,3.247,0,0,0-1.05-2.161,3.78,3.78,0,0,0-4.245-3.53,4.929,4.929,0,0,0-4.9,4.7A4.182,4.182,0,0,1,310.783,266.153Z",
    transform: "translate(-308.656 -262.981)",
    fill: "#fff",
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M303.056,255.064l.528-.145a9.842,9.842,0,0,1,5.012-1.463c3.069-.092,7.591,2.686,8.356,8.073.03.208.05.394.066.571a4.629,4.629,0,0,1,.031.469c0,.006,0,.012,0,.018a3.934,3.934,0,0,1-.024.587,9.884,9.884,0,0,1-2.973,5.676,10.626,10.626,0,0,1-3.5,2.174l-.605-.363c5.516-2.217,4.676-8.259,4.676-8.259l-1.874-3.546s-5.015-5.7-10.931-2.345l-.243-.212A10.314,10.314,0,0,1,303.056,255.064Z",
    transform: "translate(-296.039 -250.236)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M301.578,256.3l.24.211c5.918-3.354,10.932,2.346,10.932,2.346l1.873,3.547s.842,6.04-4.673,8.258l.605.364a10.744,10.744,0,0,0,1.572-.746,9.326,9.326,0,0,0,1.929-1.429,9.882,9.882,0,0,0,2.971-5.675,3.821,3.821,0,0,0,.025-.589.035.035,0,0,1,0-.019c0-.161-.016-.316-.032-.468-.014-.174-.036-.36-.066-.569-.763-5.388-5.288-8.167-8.354-8.075a9.936,9.936,0,0,0-4.98,1.442l-.032.023-.529.143A10.483,10.483,0,0,0,301.578,256.3Z",
    transform: "translate(-296.042 -250.234)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M301.578,258.6l.24.211c5.918-3.354,10.932,2.346,10.932,2.346l1.873,3.547s.842,6.04-4.673,8.258l.605.364a10.747,10.747,0,0,0,1.572-.746c1.482-1.328,3.946-5.442,2.845-7.687a22.514,22.514,0,0,1-1.572-4.2s-4.43-4.856-9.78-3.492c-.184.047-.372.1-.561.166A10.484,10.484,0,0,0,301.578,258.6Z",
    transform: "translate(-296.042 -252.535)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M333.113,267.876a1.826,1.826,0,0,1,1.852.558,2.606,2.606,0,0,1,1.214,3.244,1.826,1.826,0,0,1-1.031,1.637c-.994.372-2.255-.544-2.817-2.046S332.119,268.249,333.113,267.876Z",
    transform: "translate(-316.063 -259.654)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M336.475,271.826c.389,1.039,1.261,1.672,1.948,1.415s.93-1.308.541-2.347-1.261-1.672-1.948-1.415S336.087,270.787,336.475,271.826Z",
    transform: "translate(-318.839 -260.723)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M301.359,264.2a11.336,11.336,0,0,1,1.783.388,10.947,10.947,0,0,1,2.62-2.578,4.4,4.4,0,0,0-2.676-.029A7.669,7.669,0,0,0,301.359,264.2Z",
    transform: "translate(-295.899 -255.721)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M299.088,275.687a11.871,11.871,0,0,1,1.845-5.492c-.565-.247-1.111-.471-1.553-.643A7.349,7.349,0,0,0,299.088,275.687Z",
    transform: "translate(-294.047 -260.808)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M395.3,127.411l-3.508,2.259a.264.264,0,0,1-.368-.062l0,0-1.96-2.668a.657.657,0,0,1,.19-.9c1.237-.769,1.865-1.074,3.417-2.056a34.527,34.527,0,0,1,4.195-2.525c1.428-.627,2.009.8,1.46,1.193a10.229,10.229,0,0,0-3,4.24A1.043,1.043,0,0,1,395.3,127.411Z",
    transform: "translate(-343.325 -121.295)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M395.3,127.411l-3.508,2.259a.264.264,0,0,1-.368-.062l0,0-1.96-2.668a.657.657,0,0,1,.19-.9c1.237-.769,1.865-1.074,3.417-2.056a34.527,34.527,0,0,1,4.195-2.525c1.428-.627,2.009.8,1.46,1.193a10.229,10.229,0,0,0-3,4.24A1.043,1.043,0,0,1,395.3,127.411Z",
    transform: "translate(-343.325 -121.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M399.158,138.071l.269.718-4.488,2.23-.225-.6Z",
    transform: "translate(-346.847 -132.312)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M339.437,164.994s1.05,3.375-.793,5.276l.629.4a4.886,4.886,0,0,0,.9-5.278Z",
    transform: "translate(-310.024 -149.993)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M404.166,190.306l.137-.7a6.829,6.829,0,0,1,6.946.164l.008,1.47A8.274,8.274,0,0,0,404.166,190.306Z",
    transform: "translate(-353.054 -165.602)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M368.338,197.6s-3.659,4.905-7.212,3.428l-.115-.687s3.2,1.187,6.627-3.605Z",
    transform: "translate(-324.713 -170.837)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M358.253,277.66c.091-.041.171-.082.247-.122,1.955-1.065,6.027-5.953,7.376-9.753-2.072.555-7.323,2.077-8.962,3.632C354.974,273.257,355.924,277.05,358.253,277.66Z",
    transform: "translate(-321.337 -217.498)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M339.437,164.994s1.05,3.375-.793,5.276l.629.4a4.886,4.886,0,0,0,.9-5.278Z",
    transform: "translate(-310.024 -149.993)",
    fill: "#003fb9",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M368.338,197.6s-3.659,4.905-7.212,3.428l-.115-.687s3.2,1.187,6.627-3.605Z",
    transform: "translate(-324.713 -170.837)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M399.158,138.071l.269.718-4.488,2.23-.225-.6Z",
    transform: "translate(-346.847 -132.312)",
    fill: "#003fb9",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M404.166,190.306l.137-.7a6.829,6.829,0,0,1,6.946.164l.008,1.47A8.274,8.274,0,0,0,404.166,190.306Z",
    transform: "translate(-353.054 -165.602)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M373.587,246.781a21.461,21.461,0,0,1,1.868,1.992c2.05,2.459,4.741,6.886.362,9.3",
    transform: "translate(-332.972 -203.704)",
    fill: "none",
    stroke: "#3659a7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M368.543,254.316s7.028,5.028,3.361,10.7",
    transform: "translate(-329.659 -208.652)",
    fill: "none",
    stroke: "#3659a7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(33.345 51.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M356.213,280.569c1.617-.367,3.274-.789,4.894-1.176.81-.205,1.619-.389,2.414-.572s1.587-.343,2.273-.453c.167-.027.334-.052.459-.066.14-.02.218-.02.2-.039a.556.556,0,0,1-.12-.032l-.029-.012.034.007.07.013.281.054.577.117c.785.158,1.595.356,2.417.536,1.643.368,3.326.763,5.039,1.037l.029,0a1.57,1.57,0,0,0,1.169-2.821,35.089,35.089,0,0,0-4.572-2.763c-.8-.412-1.611-.785-2.47-1.144-.218-.091-.428-.177-.659-.257l-.341-.123-.085-.031-.044-.015-.108-.027c-.145-.036-.292-.067-.438-.093a8.007,8.007,0,0,0-1.086-.087c-.305-.007-.569,0-.831.01-1.029.045-1.931.166-2.84.285s-1.779.286-2.653.446c-1.746.347-3.44.728-5.159,1.226a3.091,3.091,0,0,0,1.533,5.985Z",
    transform: "translate(-352.409 -272.623)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M356.213,280.569c1.617-.367,3.274-.789,4.894-1.176.81-.205,1.619-.389,2.414-.572s1.587-.343,2.273-.453c.167-.027.334-.052.459-.066.14-.02.218-.02.2-.039a.556.556,0,0,1-.12-.032l-.029-.012.034.007.07.013.281.054.577.117c.785.158,1.595.356,2.417.536,1.643.368,3.326.763,5.039,1.037l.029,0a1.57,1.57,0,0,0,1.169-2.821,35.089,35.089,0,0,0-4.572-2.763c-.8-.412-1.611-.785-2.47-1.144-.218-.091-.428-.177-.659-.257l-.341-.123-.085-.031-.044-.015-.108-.027c-.145-.036-.292-.067-.438-.093a8.007,8.007,0,0,0-1.086-.087c-.305-.007-.569,0-.831.01-1.029.045-1.931.166-2.84.285s-1.779.286-2.653.446c-1.746.347-3.44.728-5.159,1.226a3.091,3.091,0,0,0,1.533,5.985Z",
    transform: "translate(-352.409 -272.623)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(22.158 4.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M417.789,286.442l2.986-.274-1.154,3.119s-2.679.083-2.664-1.3Z",
    transform: "translate(-416.957 -286.168)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M428.538,287.475l-1.9,2.345-1.918-.533,1.155-3.119Z",
    transform: "translate(-422.053 -286.168)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(22.158 4.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M417.789,286.442l2.986-.274-1.154,3.119s-2.679.083-2.664-1.3Z",
    transform: "translate(-416.957 -286.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M428.538,287.475l-1.9,2.345-1.918-.533,1.155-3.119Z",
    transform: "translate(-422.053 -286.168)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M418.223,286.154a2.249,2.249,0,0,0-1.15,2.536l-.7-.059s-.838-1.647,1.459-2.773Z",
    transform: "translate(-394.318 -281.315)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M355.359,277.555s-4.576,3.739.482,6.317l-.6.223a3.04,3.04,0,0,1-2.828-3.2A3.287,3.287,0,0,1,355.359,277.555Z",
    transform: "translate(-352.413 -275.862)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M392.744,272.774a6.82,6.82,0,0,0-.752,5.552l-.418.067a7.414,7.414,0,0,1,.681-5.675Z",
    transform: "translate(-377.944 -272.685)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M418.223,286.154a2.249,2.249,0,0,0-1.15,2.536l-.7-.059s-.838-1.647,1.459-2.773Z",
    transform: "translate(-394.318 -281.315)",
    fill: "#003fb9",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M355.359,277.555s-4.576,3.739.482,6.317l-.6.223a3.04,3.04,0,0,1-2.828-3.2A3.287,3.287,0,0,1,355.359,277.555Z",
    transform: "translate(-352.413 -275.862)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M392.744,272.774a6.82,6.82,0,0,0-.752,5.552l-.418.067a7.414,7.414,0,0,1,.681-5.675Z",
    transform: "translate(-377.944 -272.685)",
    fill: "#003fb9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M349.826,234.151l-6.945,6.656h-2.427l7.058-6.656S348.909,233.234,349.826,234.151Z",
    transform: "translate(-311.213 -195.142)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M349.826,234.151l-6.945,6.656a1.8,1.8,0,0,0-2.427,0l7.058-6.656S348.909,233.234,349.826,234.151Z",
    transform: "translate(-311.213 -195.142)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M342.4,234.924a2.132,2.132,0,0,1-.35.189,1.841,1.841,0,0,1-.646.144c-.254,0-.446-.072-.511-.22-.079-.189.072-.439.354-.649a1.884,1.884,0,0,1,.405-.227,1.644,1.644,0,0,1,.573-.141c.288-.024.511.051.58.216C342.889,234.437,342.717,234.708,342.4,234.924Z",
    transform: "translate(-311.488 -195.322)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(8.518 12.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M294.4,159.348a1.831,1.831,0,0,0,1.132-.634",
    transform: "translate(-289.486 -158.714)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M294.4,160.361a5.41,5.41,0,0,1,2.15-.724",
    transform: "translate(-289.486 -159.32)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M295.894,161.3s-.453-.249-1.494.249",
    transform: "translate(-289.486 -160.37)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(0 0.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M302.482,185.9a2.129,2.129,0,0,1-.35.189,1.841,1.841,0,0,1-.646.144c-.031-.223-.079-.525-.158-.868a6.363,6.363,0,0,0-1.486-3.007c-2.293-2.338-5.043-2.523-7.954-2.715-2.784-.185-5.664-.378-8.27-2.475-2.657-2.139-3.985-6.148-3.392-10.216.536-3.649,2.465-6.481,5.166-7.583l.388.954c-2.358.961-4.054,3.495-4.535,6.78-.542,3.711.642,7.346,3.017,9.262,2.351,1.895,4.947,2.067,7.693,2.249,2.973.2,6.052.405,8.623,3.024A7.311,7.311,0,0,1,302.307,185C302.389,185.339,302.444,185.648,302.482,185.9Z",
    transform: "translate(-280.087 -159.37)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(0 0.225)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M302.482,185.9a2.129,2.129,0,0,1-.35.189,1.841,1.841,0,0,1-.646.144c-.031-.223-.079-.525-.158-.868a6.363,6.363,0,0,0-1.486-3.007c-2.293-2.338-5.043-2.523-7.954-2.715-2.784-.185-5.664-.378-8.27-2.475-2.657-2.139-3.985-6.148-3.392-10.216.536-3.649,2.465-6.481,5.166-7.583l.388.954c-2.358.961-4.054,3.495-4.535,6.78-.542,3.711.642,7.346,3.017,9.262,2.351,1.895,4.947,2.067,7.693,2.249,2.973.2,6.052.405,8.623,3.024A7.311,7.311,0,0,1,302.307,185C302.389,185.339,302.444,185.648,302.482,185.9Z",
    transform: "translate(-280.087 -159.37)",
    fill: "#fff"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "stars",
    transform: "translate(219.999 269.66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stars-2",
    "data-name": "stars",
    transform: "translate(211.935 144.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M257.789,361.176l.845.139-.845.139-.139.845-.139-.845-.845-.139.845-.139.139-.845Z",
    transform: "translate(-256.666 -360.332)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M258.177,361.646l.5.7-.7-.5-.7.5.5-.7-.5-.7.7.5.7-.5Z",
    transform: "translate(-256.996 -360.662)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M258.749,362.218a.2.2,0,1,1-.2-.2A.2.2,0,0,1,258.749,362.218Z",
    transform: "translate(-257.569 -361.234)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stars-3",
    "data-name": "stars",
    transform: "translate(186.355 133.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M227.987,315.286l2.489.41-2.489.41-.41,2.489-.41-2.489-2.489-.41,2.489-.41.41-2.489Z",
    transform: "translate(-224.678 -312.797)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M229.13,316.67l1.47,2.05-2.05-1.47-2.05,1.47,1.47-2.05-1.47-2.05,2.05,1.47,2.05-1.47Z",
    transform: "translate(-225.651 -313.771)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M230.816,318.358a.577.577,0,1,1-.577-.578A.577.577,0,0,1,230.816,318.358Z",
    transform: "translate(-227.339 -315.458)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stars-4",
    "data-name": "stars",
    transform: "translate(232.918 170.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M270.925,407.625l2.489.41-2.489.41-.41,2.489-.41-2.489-2.489-.41,2.489-.41.41-2.489Z",
    transform: "translate(-267.616 -405.136)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M272.069,409.008l1.47,2.05-2.05-1.47-2.05,1.47,1.47-2.05-1.47-2.05,2.05,1.47,2.05-1.47Z",
    transform: "translate(-268.59 -406.109)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M273.754,410.7a.577.577,0,1,1-.577-.577A.578.578,0,0,1,273.754,410.7Z",
    transform: "translate(-270.277 -407.797)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stars-5",
    "data-name": "stars",
    transform: "translate(75.576 111.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78-2",
    "data-name": "Path 78",
    d: "M257.789,361.176l.845.139-.845.139-.139.845-.139-.845-.845-.139.845-.139.139-.845Z",
    transform: "translate(-256.666 -360.332)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79-2",
    "data-name": "Path 79",
    d: "M258.177,361.646l.5.7-.7-.5-.7.5.5-.7-.5-.7.7.5.7-.5Z",
    transform: "translate(-256.996 -360.662)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80-2",
    "data-name": "Path 80",
    d: "M258.749,362.218a.2.2,0,1,1-.2-.2A.2.2,0,0,1,258.749,362.218Z",
    transform: "translate(-257.569 -361.234)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stars-6",
    "data-name": "stars",
    transform: "translate(87.459 100.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92-2",
    "data-name": "Path 92",
    d: "M227.987,315.286l2.489.41-2.489.41-.41,2.489-.41-2.489-2.489-.41,2.489-.41.41-2.489Z",
    transform: "translate(-224.678 -312.797)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93-2",
    "data-name": "Path 93",
    d: "M229.13,316.67l1.47,2.05-2.05-1.47-2.05,1.47,1.47-2.05-1.47-2.05,2.05,1.47,2.05-1.47Z",
    transform: "translate(-225.651 -313.771)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94-2",
    "data-name": "Path 94",
    d: "M230.816,318.358a.577.577,0,1,1-.577-.578A.577.577,0,0,1,230.816,318.358Z",
    transform: "translate(-227.339 -315.458)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stars-7",
    "data-name": "stars",
    transform: "translate(97.049 137.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108-2",
    "data-name": "Path 108",
    d: "M270.925,407.625l2.489.41-2.489.41-.41,2.489-.41-2.489-2.489-.41,2.489-.41.41-2.489Z",
    transform: "translate(-267.616 -405.136)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109-2",
    "data-name": "Path 109",
    d: "M272.069,409.008l1.47,2.05-2.05-1.47-2.05,1.47,1.47-2.05-1.47-2.05,2.05,1.47,2.05-1.47Z",
    transform: "translate(-268.59 -406.109)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110-2",
    "data-name": "Path 110",
    d: "M273.754,410.7a.577.577,0,1,1-.577-.577A.578.578,0,0,1,273.754,410.7Z",
    transform: "translate(-270.277 -407.797)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stars-8",
    "data-name": "stars",
    transform: "translate(0 5.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108-3",
    "data-name": "Path 108",
    d: "M270.925,407.625l2.489.41-2.489.41-.41,2.489-.41-2.489-2.489-.41,2.489-.41.41-2.489Z",
    transform: "translate(-267.616 -405.136)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109-3",
    "data-name": "Path 109",
    d: "M272.069,409.008l1.47,2.05-2.05-1.47-2.05,1.47,1.47-2.05-1.47-2.05,2.05,1.47,2.05-1.47Z",
    transform: "translate(-268.59 -406.109)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110-3",
    "data-name": "Path 110",
    d: "M273.754,410.7a.577.577,0,1,1-.577-.577A.578.578,0,0,1,273.754,410.7Z",
    transform: "translate(-270.277 -407.797)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stars-9",
    "data-name": "stars",
    transform: "translate(322.204 145.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108-4",
    "data-name": "Path 108",
    d: "M270.925,407.625l2.489.41-2.489.41-.41,2.489-.41-2.489-2.489-.41,2.489-.41.41-2.489Z",
    transform: "translate(-267.616 -405.136)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109-4",
    "data-name": "Path 109",
    d: "M272.069,409.008l1.47,2.05-2.05-1.47-2.05,1.47,1.47-2.05-1.47-2.05,2.05,1.47,2.05-1.47Z",
    transform: "translate(-268.59 -406.109)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110-4",
    "data-name": "Path 110",
    d: "M273.754,410.7a.577.577,0,1,1-.577-.577A.578.578,0,0,1,273.754,410.7Z",
    transform: "translate(-270.277 -407.797)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stars-10",
    "data-name": "stars",
    transform: "translate(79.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108-5",
    "data-name": "Path 108",
    d: "M270.925,407.625l2.489.41-2.489.41-.41,2.489-.41-2.489-2.489-.41,2.489-.41.41-2.489Z",
    transform: "translate(-267.616 -405.136)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109-5",
    "data-name": "Path 109",
    d: "M272.069,409.008l1.47,2.05-2.05-1.47-2.05,1.47,1.47-2.05-1.47-2.05,2.05,1.47,2.05-1.47Z",
    transform: "translate(-268.59 -406.109)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110-5",
    "data-name": "Path 110",
    d: "M273.754,410.7a.577.577,0,1,1-.577-.577A.578.578,0,0,1,273.754,410.7Z",
    transform: "translate(-270.277 -407.797)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ic_rocket",
    transform: "translate(242.146 201.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plane",
    transform: "translate(0 13.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M55.108,248.453l1.672.672a3,3,0,0,1-.514,2.275,2.512,2.512,0,0,1-1.806.935L53.3,250.118Z",
    transform: "translate(-38.3 -235.812)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M53.295,250.117l1.164,2.216a2.4,2.4,0,0,0,1.381-.526,2.353,2.353,0,0,0,.422-.408,2.993,2.993,0,0,0,.517-2.274l-1.672-.672Z",
    transform: "translate(-38.298 -235.812)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M55.5,252.177l1.164,2.216a2.4,2.4,0,0,0,1.381-.526Z",
    transform: "translate(-40.499 -237.872)",
    fill: "#003fb9",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M59.5,253.153,61,254.872a2.019,2.019,0,0,1-1.731,1.5,2.19,2.19,0,0,1-1.9-.613l-.067-1.951Z",
    transform: "translate(-44.272 -238.412)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M59.5,253.153,61,254.872a2.019,2.019,0,0,1-1.731,1.5,2.19,2.19,0,0,1-1.9-.613l-.067-1.951Z",
    transform: "translate(-44.272 -238.412)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M62.437,233.056c1.944,1.988,4.527,9.341,4.412,10.337s2.828,2.711,2.828,2.711l1.17-14.6a13.65,13.65,0,0,0-2.858-1.992c-.862-.25-2.658,1.753-4.164.513S62.437,233.056,62.437,233.056Z",
    transform: "translate(-56.407 -225.322)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M66.851,243.394c-.067.553.817,1.331,1.613,1.908,0,0,0,0,.005.008.633.458,1.205.792,1.205.792l1.173-14.6s-.948-.824-1.819-1.424a4.281,4.281,0,0,0-1.038-.565c-.864-.254-2.661,1.75-4.165.513a.983.983,0,0,0-.4-.217c-.536-.109-.786.678-.9,1.5v.009a12.294,12.294,0,0,0-.092,1.736C64.382,235.045,66.962,242.4,66.851,243.394Z",
    transform: "translate(-56.406 -225.323)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M70.921,243.394c-.067.553.817,1.331,1.613,1.908-.977-1.023-.856-2.015-1.058-4.129a47.633,47.633,0,0,0-1.424-6.262,6.765,6.765,0,0,1,1.185-3.176c.7-1.076,1.344-1.557,1.862-1.657a4.281,4.281,0,0,0-1.038-.565c-.864-.254-2.661,1.75-4.165.513a.983.983,0,0,0-.4-.217l-.9,1.5v.009a12.294,12.294,0,0,0-.092,1.736C68.452,235.045,71.032,242.4,70.921,243.394Z",
    transform: "translate(-60.476 -225.323)",
    fill: "#003fb9",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M73.942,232.808S63.667,221.8,62.269,220.947a3.233,3.233,0,0,0-2.409-.559s-1.885-.471-2.474-.042-.128,1.129,1.122,2.845c2.32,3.183,12.12,12.844,12.12,12.844S73.891,235.412,73.942,232.808Z",
    transform: "translate(-57.132 -220.165)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M58,222.473c.148.216.322.456.512.716,2.319,3.185,12.122,12.846,12.122,12.846s3.263-.627,3.312-3.231c0,0-10.275-11.007-11.671-11.857a4.046,4.046,0,0,0-1.484-.569,2.319,2.319,0,0,0-.926.01l-.223-.054c-.143-.027-.341-.066-.566-.1a2.751,2.751,0,0,0-1.684.113C56.889,220.71,57.147,221.268,58,222.473Z",
    transform: "translate(-57.134 -220.164)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M86.076,223.3l.237-.181a.4.4,0,0,0,.064-.581,3.258,3.258,0,0,1-.933-1.949,2.32,2.32,0,0,0-.926.01l-.223-.054c-.18.941.763,2.162,1.233,2.7A.4.4,0,0,0,86.076,223.3Z",
    transform: "translate(-81.792 -220.376)",
    fill: "#0b3558",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M91.275,222.473a2.972,2.972,0,0,0,1.075-2.239,2.751,2.751,0,0,0-1.684.113C90.167,220.71,90.424,221.268,91.275,222.473Z",
    transform: "translate(-90.412 -220.164)",
    fill: "#003fb9",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M83.137,228.507l-.323-.333a.4.4,0,0,0-.539-.028l-.943.792a.4.4,0,0,0-.028.581l.352.358a.4.4,0,0,0,.546.018l.915-.816A.4.4,0,0,0,83.137,228.507Z",
    transform: "translate(-77.189 -224.528)",
    fill: "#003fb9",
    opacity: 0.43
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3011",
    "data-name": "Group 3011",
    transform: "translate(40.355 3.143) rotate(97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_348-2",
    "data-name": "Path 348",
    d: "M0,.6A1.743,1.743,0,0,0,1.077,0",
    transform: "translate(4.678 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349-2",
    "data-name": "Path 349",
    d: "M0,.69A5.15,5.15,0,0,1,2.047,0",
    transform: "translate(4.678 0.302)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350-2",
    "data-name": "Path 350",
    d: "M1.422.059S.991-.178,0,.3",
    transform: "translate(4.678 0.824)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_84-2",
    "data-name": "Group 84",
    transform: "translate(0 0.214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_351-2",
    "data-name": "Path 351",
    d: "M21.319,25.258a2.03,2.03,0,0,1-.333.18,1.752,1.752,0,0,1-.615.137c-.029-.212-.075-.5-.15-.827a6.057,6.057,0,0,0-1.415-2.863c-2.183-2.225-4.8-2.4-7.572-2.585-2.65-.176-5.392-.359-7.872-2.356C.832,14.908-.432,11.091.133,7.219.643,3.745,2.48,1.049,5.051,0l.369.908C3.176,1.823,1.561,4.235,1.1,7.363c-.516,3.533.611,6.993,2.873,8.817,2.239,1.8,4.709,1.967,7.324,2.14,2.83.19,5.761.386,8.209,2.879a6.959,6.959,0,0,1,1.644,3.2C21.231,24.722,21.283,25.016,21.319,25.258Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85-2",
    "data-name": "Group 85",
    transform: "translate(0 0.214)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_352-2",
    "data-name": "Path 352",
    d: "M21.319,25.258a2.03,2.03,0,0,1-.333.18,1.752,1.752,0,0,1-.615.137c-.029-.212-.075-.5-.15-.827a6.057,6.057,0,0,0-1.415-2.863c-2.183-2.225-4.8-2.4-7.572-2.585-2.65-.176-5.392-.359-7.872-2.356C.832,14.908-.432,11.091.133,7.219.643,3.745,2.48,1.049,5.051,0l.369.908C3.176,1.823,1.561,4.235,1.1,7.363c-.516,3.533.611,6.993,2.873,8.817,2.239,1.8,4.709,1.967,7.324,2.14,2.83.19,5.761.386,8.209,2.879a6.959,6.959,0,0,1,1.644,3.2C21.231,24.722,21.283,25.016,21.319,25.258Z",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404IllustrationSmall);
export default __webpack_public_path__ + "static/media/404_illustration_small.c6e197d967d419bc55d211de22b8ba5a.svg";
export { ForwardRef as ReactComponent };